import { Component, ChangeDetectionStrategy} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { DrgSelectorComponent } from 'src/app/patient-data/shared/drg-selector/drg-selector.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MmtCommonService } from 'src/app/common/services/mmt-common.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-custom-popup',
  templateUrl: './custom-popup.component.html',
  styleUrls: ['./custom-popup.component.scss']
})
export class CustomPopupComponent implements ICellRendererAngularComp {

  public cellValue:any;
  public params:any;
  public hospital:any;
  public dischargedDate:any;
  public drgWithout:any;
  hospitalData:any;
  public isCellValue:boolean;
  public isdisabled:boolean;
  today: Date = new Date();
  constructor(
    private modalService: NgbModal,
    private commonService : MmtCommonService,
    private toastrService: ToastrService
) { }

   agInit(params:any){
     this.hospitalData=params?.hospitalData;
    this.params = params;
    this.cellValue = params.value;
    this.isCellValue = !!this.cellValue;

    if(params.customFieldName ==='drgwMalnutrition' || params.customFieldName ==='drgwoMalnutrition'){
      this.isdisabled = this.isDrgFieldDisabled(params);
    }
  }

  private isDrgFieldDisabled(params: any): boolean {
    if (this.isInvalidOrMissing(this.params.data.malnutrICDDiagnosisCoded)) {
      return true;
    }
    if (this.isInvalidOrMissing(this.params.data.dischargedDate)) {
      return true;
    }
    if (params.customFieldName === 'drgwoMalnutrition') {
      return this.isInvalidOrMissing(this.params.data.drgwMalnutrition);
    }
    return false;
  }

  private isInvalidOrMissing(value: any): boolean {
    return !value || value === '' || value.trim().includes('(Data Error)') ||
      value.trim().includes('(Missing Required Data)') || value === 'Not Coded';
  }

  refresh():boolean{
    return false;
  }

  clearText(){
    this.cellValue = '';
    this.params.data[this.params.column.colId] = '';
    this.params.context.componentParent.customRefresh(this.params.column.colId);
    this.isCellValue = false;
    if(this.params.data.drgwMalnutrition === ''){
      this.params.data.drgwoMalnutrition = '';
      this.params.context.componentParent.customRefresh(['drgwMalnutrition','drgwoMalnutrition']);
    }
  }

  openDRGSelector() {
    if(this.params.column.colId === 'drgwoMalnutrition'){
      if(this.params.data.drgwMalnutrition && (this.params.data.drgwMalnutrition.trim().includes('(Data Error)') || this.params.data.drgwMalnutrition.trim().includes('(Missing Required Data)'))){
        this.checkValidDRG();
      }else if(this.params.data.drgwMalnutrition){
        this.openDRGSelectorPopup();
      }else{
        this.checkValidDRG();
      }
    }else{
      this.openDRGSelectorPopup();
    }
    
  }

  openDRGSelectorPopup() {
      let modalRef = this.modalService.open(DrgSelectorComponent, {
        size: 'lg', backdrop : 'static',
        keyboard : false
      });
  
      this.hospital = this.hospitalData;
      modalRef.componentInstance.hospitalId = this.hospital.id;
      modalRef.componentInstance.hospitalTeamName = this.hospital.costCenter;
      modalRef.componentInstance.careTypeId = this.params?.data?.careTypeId || this.hospital?.careType?.[0]?.typeId;
      if(this.params.data.dischargedDate){
        if(this.params.data.dischargedDate.trim() === '(Missing Required Data)' || this.params.data.dischargedDate.trim() ==='Data Error'){
          this.dischargedDate = this.today;
        }else{
          this.dischargedDate = new Date(this.params.data.dischargedDate.split('-').reverse().join('/'));
        }
      }else{
        this.dischargedDate = this.today;
      }
      modalRef.componentInstance.dischargeDate =  this.dischargedDate.toISOString();
      if(this.params.column.colId === 'drgwoMalnutrition'){
        this.drgWithout=true;
        modalRef.componentInstance.drgWithValue = this.params.data.drgwMalnutrition;
      }
      
      modalRef.result.then(res => {
        if ( res ) {
          if( this.drgWithout ){
            if ( this.params.data.drgwMalnutrition <= res.msdrgCode ) {
              this.params.data.drgwoMalnutrition = res.msdrgCode;
              this.cellValue = this.params.data.drgwoMalnutrition;
            } else {
              this.params.data.drgwoMalnutrition = null;
              this.cellValue = this.params.data.drgwoMalnutrition;
              this.toastrService.error('DRG without Malnutrition cannot be less than DRG with Malnutrition.')
            }
          } else {
            this.params.data.drgwMalnutrition = res.msdrgCode;
            this.cellValue = this.params.data.drgwMalnutrition;
          }
        }
        this.params.data[this.params.column.colId] = this.cellValue;
        this.params.context.componentParent.customRefresh(['drgwMalnutrition', 'drgwoMalnutrition']);
        if(this.cellValue){
          this.isCellValue = true;
        }else{
          this.isCellValue = false;
        }
      });
    
  }

  checkValidDRG(){
    if(this.params.column.colId === 'drgwoMalnutrition'){
      this.toastrService.error('Please enter valid DRG w/Malnutrition');
    }
  }

}
